<div
  class="sz-success-overlay"
  [class.is-open]="open()"
  [class.is-loading]="phase() === 'loading'"
  [attr.aria-hidden]="!open()">
  <div class="sz-success-overlay__scrim"></div>

  <div class="sz-success-overlay__stage" role="status" aria-live="polite">
    <div class="sz-success-overlay__halo" aria-hidden="true"></div>

    <div class="sz-success-overlay__badge">
      <svg class="sz-success-overlay__check" viewBox="0 0 56 56" aria-hidden="true">
        <circle class="sz-success-overlay__ring" cx="28" cy="28" r="25" />
        <path class="sz-success-overlay__tick" d="M16 29 L25 38 L41 19" />
      </svg>
    </div>

    @if (title()) {
      <div class="sz-success-overlay__title">{{ title() }}</div>
    }
    @if (subtitle()) {
      <div class="sz-success-overlay__subtitle">{{ subtitle() }}</div>
    }
  </div>
</div>
